module.exports = __webpack_public_path__ + "static/RoslindaleText-Italic-b19868fa7fa66a2991f9e52c1ca37ef9.eot";